export type LoginRoleContent = {
  FORM_TITLE?: string;
  NAME_FIELD_TITLE: string;
  NAME_FIELD_PLACEHOLDER: string;
  PASSWORD_FIELD_TITLE: string;
  PASSWORD_FIELD_PLACEHOLDER: string;
  PAGE_URL: string;
};

export interface LoginContent {
  student: LoginRoleContent;
  teacher: LoginRoleContent;
  admin: LoginRoleContent;
}

export const LOGIN_CONTENT: LoginContent = {
  student: {
    // FORM_TITLE: 'Student Login',
    NAME_FIELD_TITLE: 'Your Name',
    NAME_FIELD_PLACEHOLDER: 'Enter your name',
    PASSWORD_FIELD_TITLE: 'Code',
    PASSWORD_FIELD_PLACEHOLDER: 'Enter your code',
    PAGE_URL: '/river-map',
  },
  teacher: {
    FORM_TITLE: 'Teacher Login',
    NAME_FIELD_TITLE: 'Email',
    NAME_FIELD_PLACEHOLDER: 'Enter your email',
    PASSWORD_FIELD_TITLE: 'Password',
    PASSWORD_FIELD_PLACEHOLDER: 'Enter your password',
    PAGE_URL: '/teacher-dashboard',
  },
  admin: {
    FORM_TITLE: 'Admin Login',
    NAME_FIELD_TITLE: 'Email',
    NAME_FIELD_PLACEHOLDER: 'Enter your email',
    PASSWORD_FIELD_TITLE: 'Password',
    PASSWORD_FIELD_PLACEHOLDER: 'Enter your password',
    PAGE_URL: '/admin-dashboard',
  }
}
